export default __webpack_public_path__ + "static/media/fa-regular-400.68c5af1f.woff2";